import React, { useState } from 'react';
import './OPODashboard.css';
import OPOOverviewTab from './OPOOverviewTab';
import OPOLearningTab from './OPOLearningTab';
import OPOAgentsTab from './OPOAgentsTab';
import OPOCorneliusTab from './OPOCorneliusTab';
import OPOActivityTab from './OPOActivityTab';

const TABS = [
  { id: 'overview', label: 'Overview', component: OPOOverviewTab },
  { id: 'learning', label: 'Learning', component: OPOLearningTab },
  { id: 'agents', label: 'AI Agents', component: OPOAgentsTab },
  { id: 'cornelius', label: 'Cornelius', component: OPOCorneliusTab },
  { id: 'activity', label: 'Activity', component: OPOActivityTab },
];

const OPODashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const ActiveComponent = TABS.find(t => t.id === activeTab)?.component || OPOOverviewTab;

  return (
    <div className="opo-monitor">
      <div className="opo-tab-bar">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`opo-tab-button ${activeTab === tab.id ? 'opo-tab-active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="opo-tab-content">
        <ActiveComponent />
      </div>
    </div>
  );
};

export default OPODashboard;
